import debounce from 'lodash.debounce'
import { Select, useAsyncSelect } from 'mailup-web-components'
import PropTypes from 'prop-types'
import { useEffect, useRef } from 'react'

import { useIntl } from 'react-intl'
import {
  fetchMessageDetailsById,
  getMemoMessagesList,
  MESSAGE_SELECT_MAX_ITEMS
} from './recoil/action'

const MessageSelect = ({
  IdMessage,
  onChangeCallback,
  onErrorCallback,
  error,
  'data-mu-test': dataAttributeTest
}) => {
  const intl = useIntl()

  const getInitialItems = () => getMemoMessagesList()
  const getItemsByTerm = (searchTerm) => getMemoMessagesList(searchTerm)

  const hints = {
    loading: intl.formatMessage({ id: 'Load.MailupCommon.InputStatusLoading' }),
    moreResults: intl.formatMessage({
      id: 'Load.Filters.ActivityMessagesMoreResults'
    }),
    noResults: intl.formatMessage({ id: 'Load.Common.NoResultChosen' })
  }

  const {
    options,
    loading,
    hint,
    hintNoResults,
    onSearch,
    onChange,
    onExpandCollapse
  } = useAsyncSelect({
    initialValue: [IdMessage],
    getInitialItems,
    getItemsByTerm,
    getItemById: fetchMessageDetailsById,
    onErrorCallback,
    hints,
    maxItems: MESSAGE_SELECT_MAX_ITEMS
  })

  const { current: debouncedOnSearch } = useRef(debounce(onSearch, 350))

  const handleSearch = (s) => {
    debouncedOnSearch.cancel()
    debouncedOnSearch(s)
    return s
  }

  const handleChange = (value) => {
    if (value) {
      onChangeCallback(value)
      onChange(value)
    }
  }

  useEffect(() => {
    IdMessage > 0 && onChange(IdMessage)
  }, [IdMessage])

  return (
    <>
      <Select
        multiple={false}
        searchable
        value={IdMessage}
        hint={hint}
        hintNoResults={hintNoResults}
        onChange={handleChange}
        loading={loading}
        options={options}
        onSearch={handleSearch}
        onExpandCollapse={onExpandCollapse}
        error={error}
        placeholder={intl.formatMessage({
          id: 'Load.Task.ActionsEmailMsgSelectPlaceholder'
        })}
      />
    </>
  )
}

MessageSelect.propTypes = {
  IdMessage: PropTypes.number,
  onChangeCallback: PropTypes.func,
  onErrorCallback: PropTypes.func,
  error: PropTypes.any,
  'data-mu-test': PropTypes.string
}

export default MessageSelect
